/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Row, Col } from 'reactstrap';
import { FieldArray } from 'redux-form';
import { STRUCTURAL_RESPONSES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import ResponseDetail from './ResponseDetail/index.js';

type RenderStructuralResponseProps = {|
  modelId: string,
  responseItemKey: string,
  fields: {
    get: Function,
    getAll: Function,
    map: Function,
    push: Function,
  },
  form: string,
|};

const renderStructuralResponses = ({
  responseItemKey,
  fields,
  form,
  modelId,
}: RenderStructuralResponseProps): any => {
  const edpResponses = fields.map((field, index) => {
    const { itemKey, edpKey, method, upload } = fields.get(index);
    return responseItemKey === itemKey ? (
      <ResponseDetail
        modelId={modelId}
        form={form}
        field={field}
        responseItemKey={responseItemKey}
        edpKey={edpKey}
        method={method}
        responseId={upload}
        key="edp-structural-response"
      />
    ) : null;
  });
  return (
    <Row>
      <Col>{edpResponses}</Col>
    </Row>
  );
};

type Props = {|
  responseItemKey: number,
  modelId: string,
  form: string,
|};

const Response = (props: Props): Element<typeof FieldArray> => {
  const { responseItemKey, modelId, form } = props;

  return (
    <FieldArray
      form={form}
      responseItemKey={responseItemKey}
      modelId={modelId}
      name={STRUCTURAL_RESPONSES}
      component={renderStructuralResponses}
    />
  );
};

export default Response;
